import {
  faBed,
  faExclamationTriangle,
  faLink,
  faSteeringWheel,
  faToggleOff,
  faToggleOn,
  faTruck,
  faTruckRamp,
} from "@fortawesome/pro-solid-svg-icons";

import * as Color from "~/Color";
import { LogChartData } from "~/Log/Chart";

export type SVGAttrs = {
  readonly class: string;
  readonly viewBox: string;
  readonly fill: string;
  readonly path: string | readonly string[];
  readonly height: number;
  readonly width: number;
};

const calcHeight = (
  boxWidth: number,
  boxHeight: number,
  iconWidth: number
): number => (boxHeight * iconWidth) / boxWidth;

export const violationSVGData: SVGAttrs = {
  class: "svg-inline--fa fa-exclamation-triangle fa-w-18",
  viewBox: "0 0 576 512",
  fill: Color.guardsmanRed(),
  path: faExclamationTriangle.icon[4],
  height: calcHeight(576, 512, 18),
  width: 18,
};

export const pairingSVGData: SVGAttrs = {
  class: "svg-inline--fa fa-link fa-w-16",
  viewBox: "0 0 512 512",
  fill: Color.black(),
  path: faLink.icon[4],
  height: calcHeight(512, 512, 16),
  width: 16,
};

export const offSVGData: SVGAttrs = {
  class: "svg-inline--fa fa-toggle-off fa-w-18",
  viewBox: "0 0 576 512",
  fill: Color.steel(),
  path: faToggleOff.icon[4],
  height: calcHeight(640, 512, 18),
  width: 18,
};

export const sbSVGData: SVGAttrs = {
  class: "svg-inline--fa fa-bed fa-w-20",
  viewBox: "0 0 576 512",
  fill: Color.steel(),
  path: faBed.icon[4],
  height: calcHeight(576, 512, 20),
  width: 20,
};

export const truckSVGData: SVGAttrs = {
  class: "svg-inline--fa fa-truck fa-w-20",
  viewBox: "0 0 640 512",
  fill: Color.azure(),
  path: faTruck.icon[4],
  height: calcHeight(640, 512, 20),
  width: 20,
};

export const toggleOnSVGData: SVGAttrs = {
  class: "svg-inline--fa fa-toggle-on fa-w-18",
  viewBox: "0 0 576 512",
  fill: Color.green(),
  path: faToggleOn.icon[4],
  height: calcHeight(576, 512, 18),
  width: 18,
};

export const toggleOffSVGData: SVGAttrs = {
  class: "svg-inline--fa fa-toggle-off fa-w-18",
  viewBox: "0 0 576 512",
  fill: Color.steel(),
  path: faToggleOff.icon[4],
  height: calcHeight(576, 512, 18),
  width: 18,
};

export const sleeperBerth = () => `
    <svg class="${sbSVGData.class}" viewBox="${sbSVGData.viewBox}">
        <path fill="${sbSVGData.fill}" d="${sbSVGData.path}"/>
    </svg>
  `;

export const truckSVG = () => `
    <svg class="${truckSVGData.class}" viewBox="${truckSVGData.viewBox}">
        <path fill="${truckSVGData.fill}" d="${truckSVGData.path}"/>
    </svg>
  `;

export const toggleOn = () => `
    <svg class="${toggleOnSVGData.class}" viewBox="${toggleOnSVGData.viewBox}">
        <path fill="${toggleOnSVGData.fill}" d="${toggleOnSVGData.path}"/>
    </svg>
  `;

export const toggleOff = () => `
    <svg class="${toggleOffSVGData.class}" viewBox="${toggleOffSVGData.viewBox}">
        <path fill="${toggleOffSVGData.fill}" d="${toggleOffSVGData.path}"/>
    </svg>
  `;

export const personalUse = () => `
    <svg class="svg-inline--fa fa-steering-wheel fa-w-16" viewBox="0 0 496 512">
        <path fill="${Color.green()}" d="${faSteeringWheel.icon[4]}"/>
    </svg>
  `;

export const yardMove = () => `
    <svg class="svg-inline--fa fa-truck-ramp fa-w-20" viewBox="0 0 640 512">
        <path fill="${Color.azure()}" d="${faTruckRamp.icon[4]}"/>
    </svg>
  `;

export const toStatusSVG = (d: LogChartData): string => {
  switch (d.event.status) {
    case "D":
      return truckSVG();
    case "ON":
      return toggleOn();
    case "YM":
      return yardMove();
    case "OFF":
      return toggleOff();
    case "SB":
      return sleeperBerth();
    case "PU":
      return personalUse();
    default:
      return toggleOff();
  }
};
